var _effectorFileName = "/builds/gmini/front-ui-kit/src/ErrorPageTemplate/ErrorPageTemplate.tsx";
import { GTechLogo } from '../icons';
import { ErrorPageTemplateErrorCodeText, ErrorPageTemplateHeader, ErrorPageTemplateHeaderLink, ErrorPageTemplateHeaderText, ErrorPageTemplateMediumText, ErrorPageTemplateSmallText, ErrorPageTemplateWrapper } from './ErrorPageTemplate.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ErrorPageTemplate = ({
  composition,
  mediumText,
  smallText,
  errorCode
}) => /*#__PURE__*/_jsxs(ErrorPageTemplateWrapper, {
  children: [/*#__PURE__*/_jsxs(ErrorPageTemplateHeader, {
    children: [/*#__PURE__*/_jsx(GTechLogo, {}), /*#__PURE__*/_jsxs(ErrorPageTemplateHeaderText, {
      children: ["Global Technology Evolving for Construction", ' ', /*#__PURE__*/_jsx(ErrorPageTemplateHeaderLink, {
        href: "https://g-tec.ru",
        target: "_blank",
        children: "https://g-tec.ru"
      })]
    })]
  }), composition, /*#__PURE__*/_jsx(ErrorPageTemplateMediumText, {
    children: mediumText
  }), /*#__PURE__*/_jsx(ErrorPageTemplateSmallText, {
    children: smallText
  }), /*#__PURE__*/_jsxs(ErrorPageTemplateErrorCodeText, {
    children: ["\u041A\u043E\u0434 \u043E\u0448\u0438\u0431\u043A\u0438: ", /*#__PURE__*/_jsx("span", {
      style: {
        fontWeight: 400
      },
      children: errorCode
    })]
  })]
});